import { Features } from '@Config/Features';
import { Variants } from '@Config/Variants';

export enum Experiments {
  PROVIDER_PAGE_WORDING = 'wsssh-265',
  QUESTIONNAIRE_VISUALIZATION = 'wsssh-829',
  HIDE_VIDEO_JOURNEY = 'wsssh-1561'
}

export type FeatureSet = Record<Features, boolean>;
export type FeatureSets = Record<Variants, FeatureSet>;

export const ExperimentFeatureSets: FeatureSets = <FeatureSets>{};

/**
 * Test if the new wording on the provider page increases transitions to Zava
 */
ExperimentFeatureSets[Experiments.PROVIDER_PAGE_WORDING] = (() => {
  const settings = {};
  settings[Variants.default] = {};
  settings[Variants.default][Features.providerPageWording] = false;

  settings[Variants.v1] = {};
  settings[Variants.v1][Features.providerPageWording] = true;

  return settings;
})();

/**
 * Test if the new visualization improves the transitions to ZAVA
 * https://app.optimizely.com/v2/projects/17522040231/experiments/21474311068/variations
 */
ExperimentFeatureSets[Experiments.QUESTIONNAIRE_VISUALIZATION] = (() => {
  const settings = {};

  settings[Variants.default] = {};
  settings[Variants.default][Features.questionnaireVisualization] = false;

  settings[Variants.v1] = {};
  settings[Variants.v1][Features.questionnaireVisualization] = true;

  return settings;
})();

/**
 * Hides the videoconsultation journey
 * https://app.optimizely.com/v2/projects/17522040231/experiments/21474311068/variations
 */
ExperimentFeatureSets[Experiments.HIDE_VIDEO_JOURNEY] = (() => {
  const settings = {};

  settings[Variants.default] = {};
  settings[Variants.default][Features.hideVideoJourney] = false;

  settings[Variants.v1] = {};
  settings[Variants.v1][Features.hideVideoJourney] = true;

  return settings;
})();
